import { http } from "../../webDi";
import actions from "./actions";
import repositories from "./repositories";
import presenters from "./presenters";
import useCases from "./useCases";
var cRepositorires = repositories(http);
var cUseCases = useCases(cRepositorires);
var cActions = actions();
var cPresenters = presenters(cUseCases, cActions);
export default {
    search: cPresenters.search,
};
